import { Card, CardHeader } from "@mui/material";
import UsersApi from "Classes/API/UsersApi";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import React, { useEffect, useState, useContext } from "react";
import ChartComponent from "./ChartComponent";
import Loader from "layouts/loader/loader";
import { LanguageContext } from "App";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

const PackagesStatistics = () => {
  const [loading, setLoading] = useState(false);
  const [Page, setPage] = useState(1);
  const [PaginationPages, setPaginationPages] = useState(0);

  const [PackagesStatistics, setPackagesStatistics] = useState({});
  const { translations } = useContext(LanguageContext);

  const [PostPaidAmountArray, setPostPaidAmountArray] = useState([]);
  const [PostPaidAmountUsedArray, setPostPaidAmountUsedArray] = useState([]);
  const [RefundableAmountArray, setRefundableAmountArray] = useState([]);
  const [AmountDueArray, setAmountDueArray] = useState([]);
  const [AmountPaidArray, setAmountPaidArray] = useState([]);
  const [AmountUsedArray, setAmountUsedArray] = useState([]);
  const [DiscountedAmountArray, setDiscountedAmountArray] = useState([]);
  const [DiscountedAmountUsedArray, setDiscountedAmountUsedArray] = useState(
    []
  );
  const [isLoaded, setIsLoaded] = useState(false);

  const [PostPaidPackageNames, setPostPaidPackageNames] = useState([]);
  const [PostPaidUsedPackageNames, setPostPaidUsedPackageNames] = useState([]);
  const [RefundableAmountPackageNames, setRefundableAmountPackageNames] =
    useState([]);
  const [AmountDuePackageNames, setAmountDuePackageNames] = useState([]);
  const [AmountPaidPackageNames, setAmountPaidPackageNames] = useState([]);
  const [AmountUsedPackageNames, setAmountUsedPackageNames] = useState([]);
  const [DiscountedAmountPackageNames, setDiscountedAmountPackageNames] =
    useState([]);
  const [
    DiscountedAmountUsedPackageNames,
    setDiscountedAmountUsedPackageNames,
  ] = useState([]);

  const getPackagesStatistics = async () => {
    try {
      UsersApi.GetPackagesStatistics().then((res) => {
        setIsLoaded(true);
        console.log(res.data);
        setPackagesStatistics(res.data);
        setLoading(false);
      });
    } catch (error) {
      console.error("Error fetching Packages Statistics data:", error);
    }
  };

  useEffect(() => {
    if (PackagesStatistics && PackagesStatistics.topTenPostPaid) {
      const postPaidPackageNames = PackagesStatistics.topTenPostPaid.map(
        (item) => item.packageName
      );
      const postPaidAmountArray = PackagesStatistics.topTenPostPaid.map(
        (item) => (item.postPaidAmount ? item.postPaidAmount : 0)
      );

      const postPaidUsedPackageNames =
        PackagesStatistics.topTenPostPaidUsed.map((item) => item.packageName);
      const postPaidUsedAmountArray = PackagesStatistics.topTenPostPaidUsed.map(
        (item) => (item.postPaidAmountUsed ? item.postPaidAmountUsed : 0)
      );

      const refundableAmountPackageNames =
        PackagesStatistics.topTenRefundableAmount.map(
          (item) => item.packageName
        );
      const refundableAmountArray =
        PackagesStatistics.topTenRefundableAmount.map((item) =>
          item.refundableAmount ? item.refundableAmount : 0
        );

      const amountDuePackageNames = PackagesStatistics.topTenAmountDue.map(
        (item) => item.packageName
      );
      const amountDueArray = PackagesStatistics.topTenAmountDue.map((item) =>
        item.amountDue ? item.amountDue : 0
      );

      const amountPaidPackageNames = PackagesStatistics.topTenAmountPaid.map(
        (item) => item.packageName
      );
      const amountPaidArray = PackagesStatistics.topTenAmountPaid.map((item) =>
        item.amountPaid ? item.amountPaid : 0
      );

      const amountUsedPackageNames = PackagesStatistics.topTenAmountUsed.map(
        (item) => item.packageName
      );
      const amountUsedArray = PackagesStatistics.topTenAmountUsed.map((item) =>
        item.amountUsed ? item.amountUsed : 0
      );

      const discountedAmountPackageNames =
        PackagesStatistics.topTenDiscountedAmount.map(
          (item) => item.packageName
        );
      const discountedAmountArray =
        PackagesStatistics.topTenDiscountedAmount.map((item) =>
          item.discountedAmount ? item.discountedAmount : 0
        );

      const discountedAmountUsedPackageNames =
        PackagesStatistics.topTenDiscountedAmountUsed.map(
          (item) => item.packageName
        );
      const discountedAmountUsedArray =
        PackagesStatistics.topTenDiscountedAmountUsed.map((item) =>
          item.discountedAmountUsed ? item.discountedAmountUsed : 0
        );

      setPostPaidPackageNames(postPaidPackageNames);
      setPostPaidAmountArray(postPaidAmountArray);

      setPostPaidUsedPackageNames(postPaidUsedPackageNames);
      setPostPaidAmountUsedArray(postPaidUsedAmountArray);

      setRefundableAmountPackageNames(refundableAmountPackageNames);
      setRefundableAmountArray(refundableAmountArray);

      setAmountDuePackageNames(amountDuePackageNames);
      setAmountDueArray(amountDueArray);

      setAmountPaidPackageNames(amountPaidPackageNames);
      setAmountPaidArray(amountPaidArray);

      setAmountUsedPackageNames(amountUsedPackageNames);
      setAmountUsedArray(amountUsedArray);

      setDiscountedAmountPackageNames(discountedAmountPackageNames);
      setDiscountedAmountArray(discountedAmountArray);

      setDiscountedAmountUsedPackageNames(discountedAmountUsedPackageNames);
      setDiscountedAmountUsedArray(discountedAmountUsedArray);
    }
  }, [PackagesStatistics]);

  const postPaidChartData = {
    labels: PostPaidPackageNames,
    datasets: [
      {
        label: "Post paid amount",
        data: PostPaidAmountArray,
        backgroundColor: [
          "rgba(255, 99, 132, 0.5)",
          "rgba(54, 162, 235, 0.5)",
          "rgba(255, 206, 86, 0.5)",
          "rgba(75, 192, 192, 0.5)",
          "rgba(153, 102, 255, 0.5)",
          "rgba(255, 159, 64, 0.5)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const postPaidUsedChartData = {
    labels: PostPaidUsedPackageNames,
    datasets: [
      {
        label: "Post paid used",
        data: PostPaidAmountUsedArray,
        backgroundColor: ["rgba(255, 99, 132, 0.5)", "rgba(54, 162, 235, 0.5)"],
        borderColor: ["rgba(255, 99, 132, 1)", "rgba(54, 162, 235, 1)"],
        borderWidth: 1,
      },
    ],
  };

  const refundableAmountChartData = {
    labels: RefundableAmountPackageNames,
    datasets: [
      {
        label: "Refundable amount",
        data: RefundableAmountArray,
        backgroundColor: ["rgba(255, 99, 132, 0.5)", "rgba(54, 162, 235, 0.5)"],
        borderColor: ["rgba(255, 99, 132, 1)", "rgba(54, 162, 235, 1)"],
        borderWidth: 1,
      },
    ],
  };

  const amountDueChartData = {
    labels: AmountDuePackageNames,
    datasets: [
      {
        label: "Amount due",
        data: AmountDueArray,
        backgroundColor: ["rgba(255, 99, 132, 0.5)", "rgba(54, 162, 235, 0.5)"],
        borderColor: ["rgba(255, 99, 132, 1)", "rgba(54, 162, 235, 1)"],
        borderWidth: 1,
      },
    ],
  };

  const amountPaidChartData = {
    labels: AmountPaidPackageNames,
    datasets: [
      {
        label: "Amount paid",
        data: AmountPaidArray,
        backgroundColor: ["rgba(255, 99, 132, 0.5)", "rgba(54, 162, 235, 0.5)"],
        borderColor: ["rgba(255, 99, 132, 1)", "rgba(54, 162, 235, 1)"],
        borderWidth: 1,
      },
    ],
  };

  const amountUsedChartData = {
    labels: AmountUsedPackageNames,
    datasets: [
      {
        label: "Amount used",
        data: AmountUsedArray,
        backgroundColor: ["rgba(255, 99, 132, 0.5)", "rgba(54, 162, 235, 0.5)"],
        borderColor: ["rgba(255, 99, 132, 1)", "rgba(54, 162, 235, 1)"],
        borderWidth: 1,
      },
    ],
  };

  const discountedAmountChartData = {
    labels: DiscountedAmountPackageNames,
    datasets: [
      {
        label: "Discounted amount",
        data: DiscountedAmountArray,
        backgroundColor: ["rgba(255, 99, 132, 0.5)", "rgba(54, 162, 235, 0.5)"],
        borderColor: ["rgba(255, 99, 132, 1)", "rgba(54, 162, 235, 1)"],
        borderWidth: 1,
      },
    ],
  };

  const discountedAmountUsedChartData = {
    labels: DiscountedAmountUsedPackageNames,
    datasets: [
      {
        label: "Discounted amount used",
        data: DiscountedAmountUsedArray,
        backgroundColor: ["rgba(255, 99, 132, 0.5)", "rgba(54, 162, 235, 0.5)"],
        borderColor: ["rgba(255, 99, 132, 1)", "rgba(54, 162, 235, 1)"],
        borderWidth: 1,
      },
    ],
  };

  useEffect(() => {
    setLoading(true);
    getPackagesStatistics();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!isLoaded ? (
        <Loader />
      ) : (
        <>
          <div className="container">
            <div className="row">
              <div className="col-md-4">
                <Card
                  sx={{
                    padding: "1em",
                    margin: "1em 0 0 0",
                    backgroundColor: "#ff6384",
                  }}
                >
                  <CardHeader
                    title={translations.StasticsFeedbackTotalPostPaidAmount}
                  />
                  <MDBox
                    mb={3}
                    sx={{ display: "flex", justifyContent: "space-around" }}
                  >
                    {Number(PackagesStatistics.totalPostPaidAmount).toFixed(2)}{" "}
                    EGP
                  </MDBox>
                </Card>
              </div>
              <div className="col-md-4">
                <Card
                  sx={{
                    padding: "1em",
                    margin: "1em 0 0 0",
                    backgroundColor: "#ffce56",
                  }}
                >
                  <CardHeader
                    title={translations.StasticsFeedbackTotalPostPaidUsed}
                  />
                  <MDBox
                    mb={3}
                    sx={{ display: "flex", justifyContent: "space-around" }}
                  >
                    {Number(PackagesStatistics.totalPostPaidUsed).toFixed(2)}{" "}
                    EGP
                  </MDBox>
                </Card>
              </div>
              <div className="col-md-4">
                <Card
                  sx={{
                    padding: "1em",
                    margin: "1em 0 0 0",
                    backgroundColor: "#36a2eb",
                  }}
                >
                  <CardHeader
                    title={translations.StasticsFeedbackTotalPrePaid}
                  />
                  <MDBox
                    mb={3}
                    sx={{ display: "flex", justifyContent: "space-around" }}
                  >
                    {Number(PackagesStatistics.totalPrePaid).toFixed(2)} EGP
                  </MDBox>
                </Card>
              </div>
            </div>
          </div>

          <div
            className="container"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div className="row" style={{ display: "flex", flex: 1 }}>
              {[
                {
                  title: translations.StasticsFeedbackTop10PostPaid,
                  data: postPaidChartData,
                },
                {
                  title: translations.StasticsFeedbackTop10PostPaidUsed,
                  data: postPaidUsedChartData,
                },
                {
                  title:
                    translations.StasticsFeedbackTop10RefundableAmountPackages,
                  data: refundableAmountChartData,
                },
                {
                  title: translations.StasticsFeedbackTop10AmountDue,
                  data: amountDueChartData,
                },
                {
                  title: translations.StasticsFeedbackTop10AmountPaid,
                  data: amountPaidChartData,
                },
                {
                  title: translations.StasticsFeedbackTop10AmountUsed,
                  data: amountUsedChartData,
                },
                {
                  title: translations.StasticsFeedbackTop10Discountedamount,
                  data: discountedAmountChartData,
                },
                {
                  title: translations.StasticsFeedbackTop10DiscountedAmountUsed,
                  data: discountedAmountUsedChartData,
                },
              ].map((chart, index) => (
                <div
                  key={index}
                  className="col-md-12"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <Card sx={{ padding: "1em", margin: "1em 0 0 0", flex: 1 }}>
                    <CardHeader title={chart.title} />
                    <MDBox
                      mb={3}
                      sx={{ display: "flex", justifyContent: "space-around" }}
                    >
                      <ChartComponent chartData={chart.data} />
                    </MDBox>
                  </Card>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </DashboardLayout>
  );
};

export default PackagesStatistics;
